function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-548 -136)"
}, /*#__PURE__*/React.createElement("path", {
  id: "sort_svg__sort-icon-top",
  className: "sort_svg__a",
  d: "M10.991 14.836l-2.473-2.474-1.1 1.1 3.573 3.581 3.581-3.581-1.108-1.1z",
  transform: "translate(540.59 133)"
}), /*#__PURE__*/React.createElement("path", {
  id: "sort_svg__sort-icon-bottom",
  className: "sort_svg__a",
  d: "M10.991 5.208l2.473 2.473 1.1-1.1L10.991 3 7.41 6.581l1.108 1.1z",
  transform: "translate(540.59 133)"
}));

function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.162 14.044"
  }, props), _ref, _ref2);
}

export default SvgSort;